/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

import { useAppSelector } from '../../../app/hooks';
import { selectPearlUserInfo } from './userSlice';
import styles from './Loading.module.scss';

function Loading({ variant }: { variant?: 'compact' | 'full' }) {
  const navigate = useNavigate();
  const pearlUserInfo = useAppSelector(selectPearlUserInfo);

  useEffect(() => {
    if (!pearlUserInfo) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 3000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pearlUserInfo]);

  return (
    <div className={variant === 'compact' ? styles.loading : styles.circleLoading} role="status" aria-label="Loading">
      {variant === 'compact' ? (
        <CircularProgress aria-hidden="true" />
      ) : (
        <div className={styles.circleViewport} aria-hidden="true">
          <div className={styles.circles} />
        </div>
      )}
    </div>
  );
}

export default Loading;
